<template>
  <div>
    <div class="a-tab__title-block">
      <h3>{{$t('form.lot.delivery-dates')}}</h3>
    </div>

    <div class="a-container-form admin-buy__block ">
      <base-delivery-schedule :schedule="schedule"
                              :lot-catalog="retend.lot"
                              :can-edit="canEditDeliverySchedule"
                              @update="onUpdate">
      </base-delivery-schedule>
    </div>
  </div>
</template>

<script>
  import PermissionsMixins from '../mixins/permissions'
  import CommonMixins from '../mixins/common'

  import BaseDeliverySchedule from "../common/base-DeliverySchedule";

  export default {
    components: {
      BaseDeliverySchedule
    },

    props: {
      lot: {
        type: Object,
        required: true
      },

      retend: {
        type: Object,
        required: true
      }
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    computed: {
      schedule() {
        return this.retend.parts;
      },

      canEditDeliverySchedule() {
        return this.canEditRetend;
      }
    },

    methods: {
      async onUpdate(schedule) {
        Object.assign(this.retend.parts, schedule);
        await this.saveForm();
      }
    }
  }
</script>

<style scoped>

</style>
